import RequiredActions from './required-actions';
import FieldValidators from './field-validators';

export function isFieldRequired(name) {
  return name in FieldValidators;
}

export function validateField(show, name) {
  if (isFieldRequired(name)) {
    return FieldValidators[name]
      .map(validate => validate(show, name))
      .filter(error => error !== undefined);
  }
  return [];
}

export function isFieldValid(show, name) {
  if (isFieldRequired(name)) {
    return validateField(show, name).length === 0;
  }
  return true;
}

export function getInvalidFields(show) {
  const fields = {};

  Object.keys(FieldValidators).forEach(field => {
    const errors = validateField(show, field);
    if (errors.length > 0) {
      fields[field] = errors;
    }
  });

  return fields;
}

export const requiredFields = [
  'image',
  'name',
  'description',
  'rss.subtitle',
  'rss.summary',
  'rss.author',
  'rss.ownerEmail',
];

export function getRequiredActions(show) {
  const actions = [];
  const fields = getInvalidFields(show);

  if (fields.image) {
    actions.push(RequiredActions.UPLOAD_COVER_IMAGE);
  }

  if (fields.name) {
    actions.push(RequiredActions.ENTER_VALID_NAME);
  }

  if (fields.description) {
    actions.push(RequiredActions.ADD_DESCRIPTION);
  }

  if (
    fields['rss.subtitle'] ||
    fields['rss.summary'] ||
    fields['rss.author'] ||
    fields['rss.email']
  ) {
    actions.push(RequiredActions.ADD_RSS_SETTINGS);
  }

  return actions;
}

export default function isShowValid(show) {
  return Object.keys(FieldValidators).every(field => isFieldValid(show, field));
}
